/* 
 	* 指令下发组件 
 	* 描述：InsGT520CaliVehicles指令下发
 	* 创建时间：2017-05-3 
 	* 创建人：baixx 
*/
<template>
    <div>
     	<form class="form-horizontal pt10px">
     		<div class="form-group">
				<label class="col-sm-2 control-label">指令参数</label>
				<div class="col-sm-4">
					<input type="text" class="form-control" v-model="vehicles" readonly="readonly"> 
			    </div>	
				<div class="col-sm-1 text-right">
				<span class="red dis_block  pt5px">*</span>
				</div>
			    <div class="col-sm-4">
			    	<!--<select2 v-model="vehicles" :options="vehicleList"></select2>-->
					<select class="form-control" v-model="vehicles">
						<option value="">车型列表</option>
						<option value="1">标准OBD</option>
						<option value="2">丰田</option>
						<option value="3">日产</option>
						<option value="4">本田，宝马</option>
						<option value="5">大众</option>
						<option value="6">通用</option>
						<option value="7">福特</option>
						<option value="8">标致</option>
						<option value="9">雪铁龙</option>
						<option value="10">奔驰</option>
						<option value="11">斯巴鲁</option>
						<option value="12">起亚</option>
						<option value="13">现代</option>
						<option value="14">沃尔沃</option>
						<option value="15">雷诺</option>
						<option value="18">名爵</option>
						<option value="19">长安</option>
						<option value="20">铃木</option>
						<option value="21">帝豪</option>
						<option value="22">传祺</option>
						<option value="23">长城</option>
						<option value="24">荣威</option>
						<option value="25">九龙</option>
						<option value="26">欧宝</option>
						<option value="27">海马</option>
						<option value="28">北汽</option>
						<option value="29">中兴</option>
						<option value="30">中泰</option>
						<option value="31">路虎</option>
						<option value="32">宝马</option>
						<option value="33">奔腾</option>
						<option value="34">哈弗</option>
						<option value="35">中华</option>
						<option value="36">五十铃</option>
						<option value="37">比亚迪</option>
						<option value="38">吉利</option>
						<option value="39">风行</option>
						<option value="40">SMART</option>
						<option value="41">华晨</option>
						<option value="42">风神</option>
						<option value="43">大宇</option>
						<option value="44">双龙</option>
						<option value="45">华泰</option>
						<option value="46">捷豹</option>
						<option value="47">江淮</option>
						<option value="48">陆风</option>
						<option value="49">大发</option>
						<option value="50">萨博</option>
						<option value="51">马自达</option>
						<option value="52">三菱</option>
						<option value="53">罗孚</option>
						<option value="54">雷克萨斯</option>
					</select>
			    </div>	
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
			 <div class="form-group text-right pt10px" >
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
	    </form>
    </div>	
</template>
<script>
	import Select2 from 'components/common/Select2'
	export default {
		name: "InsGT520CaliVehicles",
		components:{
			Select2
		},
		data() {
			return {
				vehicles :"",              //车系选择
				alertMsg:'',
				vehicleList:[
					{id:0,text:'车型列表'},
					{id:1,text:'标准OBD'}
				]
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {	
			resetInput(){
				this.vehicles = ''
				this.alertMsg = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				if(this.vehicles != '')
				{
					this.alertMsg=''
				}else{
					this.alertMsg='请选择制定类型中存在的车系'
					return
				}
				let arr = ["SETPRM","OBDCMD","CAR",this.vehicles]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// InsGT520CaliVehicles.vue?10952c7c